import { createSceneTask } from '@/services/templateCenter';
import {
  fetchWorkspaceTaskRoles,
  getUserSharingTree,
  nodeData,
} from '@/services/workbench';
import { Alert, Button } from '@ai-indeed/idp-ui';
import { createSearchParams, useNavigate, useSearchParams } from '@umijs/max';
import { Form, Modal, message } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import MemberSelectModal from '../MemberSelectModal';
import {
  DepartmentMemberOrgEnum,
  DepartmentType,
  UserType,
} from '../MemberSelectModal/interface';
import { CustomSelect } from './CustomSelect';
import styles from './index.less';
import { INodeInfo, IOption } from './type';
interface Props {
  visible: boolean;
  templateCode: string;
  onCancel: () => void;
}
/***
 * (｀ﾍ´)=3[○･｀Д´･ ○]
 * fixbug
 * 新需求新需求新需求！！！！！！！
 * NOT DY
 */
export const NewTaskModal = ({ visible, onCancel, templateCode }: Props) => {
  const navigate = useNavigate();
  const [urlParams] = useSearchParams();
  const workspaceUid = urlParams.get('uid') || '';
  const info = {
    resource_code: templateCode || '',
    resource_type: 4,
  };
  const [form] = Form.useForm();
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [index, setIndex] = useState(0);
  const [selectVisible, setSelectVisible] = useState(false);
  const [nodeDataList, setNodeDataList] = useState<INodeInfo[]>([]);
  const [userList, setUserList] = useState<UserType[]>([]);
  const [departmentList, setDepartmentList] = useState<DepartmentType[]>([]);
  const [defaultChecked, setDefaultChecked] = useState<IOption[]>([]);
  const [loading, setLoading] = useState(false);

  const handleSearch = useCallback(
    (value: string) => {
      setLoading(true);
      getUserSharingTree({
        keyword: value,
        resource_type: info.resource_type,
        // resource_code: templateCode || '',
      })
        .then(({ data }) => {
          const { dept_infos = [], users = [] } = data || {};
          const value1 = dept_infos.map((item: any) => {
            return {
              key: item.dept_uid,
              label: item.dept_name,
              value: item.dept_uid,
              disabled: item.is_bind,
              type: DepartmentMemberOrgEnum.DEPARTMENT,
            };
          });
          const value2 = users.map((item: any) => {
            return {
              label: item.username,
              value: item.ou_uid,
              key: item.ou_uid,
              avatar: item?.avatar,
              disabled: item.is_bind,
              type: DepartmentMemberOrgEnum.USER,
            };
          });
          setUserList(value2);
          setDepartmentList(value1);
        })
        .finally(() => setLoading(false));
    },
    [info],
  );

  const handleDepartmentChange = useCallback((curDepUid: string) => {
    // 当点击下级的时候
    setLoading(true);
    getUserSharingTree({
      dept_uid: curDepUid,
      resource_type: info.resource_type,
      // resource_code: info.resource_code,
    }).then(({ data }) => {
      const { dept_infos = [], users = [] } = data || {};
      const value1 = dept_infos.map(
        (item: { dept_uid: any; dept_name: any; is_bind: any }) => {
          return {
            key: item.dept_uid,
            label: item.dept_name,
            value: item.dept_uid,
            disabled: item.is_bind,
            type: DepartmentMemberOrgEnum.DEPARTMENT,
          };
        },
      );
      const value2 = users.map(
        (item: { username: any; ou_uid: any; avatar: any; is_bind: any }) => {
          return {
            label: item.username,
            value: item.ou_uid,
            key: item.ou_uid,
            avatar: item?.avatar,
            disabled: item.is_bind,
            type: DepartmentMemberOrgEnum.USER,
          };
        },
      );
      setUserList(value2);
      setDepartmentList(value1);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    handleSearch('');
  }, []);

  const getSecondSelectValue = (list: IOption[]) => {
    list.forEach((item) => {
      // 由于自定义的tagRender，对于常量值只接受label和value，所以这里把avatar拼接到value中
      // 后面会去除
      item.value = item.value + '_' + item.avatar + '_' + item.type;
    });
    const origin = form.getFieldValue(['users', index]);
    form.setFieldValue(['users', index], origin.concat(list));
  };

  const dataFormat = (data: nodeData) => {
    const dataList: INodeInfo[] = [];
    const defaultList: IOption[][] = [];
    const { node_head_role_list, default_node_head_user_list, role_user_list } =
      data;
    for (const node of node_head_role_list) {
      let options: IOption[] = [];
      const defaultUserList = default_node_head_user_list.find(
        (item) => item.node_code === node.node_code,
      );
      const userList = (defaultUserList?.head_list || []).map((item) => {
        return {
          key: item.uid,
          label: item.name,
          value: item.uid + '_' + item.avatar + '_' + item.type,
          type: item.type,
          avatar: item.avatar || '',
        };
      });
      defaultList.push(userList);

      node.roles.forEach((role) => {
        const user = role_user_list.find((item) => item.role_id === role.id);
        if (user) {
          const roleList = user.users.map((item) => {
            return {
              key: item.uid,
              value: item.uid + '_' + item.avatar + '_0',
              label: item.name,
              avatar: item.avatar,
              type: DepartmentMemberOrgEnum.USER,
            };
          });
          options = options.concat(roleList);
        }
      });
      // obj.options = obj.options?.filter(
      //   (item) => !obj.defaultuser.includes(item),
      // );
      dataList.push({
        key: node.node_code,
        name: node.node_name,
        roles: node.roles.map((item) => item.name).join('、'),
        options: options,
      });
    }
    return { nodes: dataList, defaultValue: defaultList };
  };

  // 根据选择的模板获取角色信息
  const fetchRoleInfos = (templateCode: string) => {
    fetchWorkspaceTaskRoles({ template_code: templateCode }).then(
      (res) => {
        const { nodes, defaultValue } = dataFormat(res.data);
        setNodeDataList(nodes);
        form.setFieldValue('users', defaultValue);
      },
      () => {
        setNodeDataList([]);
      },
    );
  };

  const showSelect = (index: number) => {
    setIndex(index);
    setDefaultChecked(form.getFieldValue(['users', index]));
    setSelectVisible(true);
  };

  const toCrossSetting = (value: {
    unique_num: string;
    template_code: string;
  }) => {
    const { template_code, unique_num } = value;
    navigate({
      pathname: '/cross/task-setting',
      search: createSearchParams({
        'task-code': unique_num,
        'template-code': template_code,
      }).toString(),
    });
  };

  // 提交数据
  const handleSubmit = async () => {
    form.validateFields().then((value) => {
      createSceneTask({
        template_code: templateCode,
        workspace_uid: workspaceUid,
        node_head: nodeDataList.map((v, index) => ({
          node_code: v.key,
          heads: value.users[index].map((item: IOption) => {
            return {
              type: item.type || DepartmentMemberOrgEnum.USER,
              name: item.label,
              uid: item.key,
              avatar: item.avatar,
            };
          }),
        })),
      })
        .then((res) => {
          onCancel?.();
          message.success('新建成功', 2).then(() => {
            toCrossSetting(res.data);
          });
        })
        .finally(() => {
          setBtnDisabled(false);
        });
    });
  };

  useEffect(() => {
    fetchRoleInfos(templateCode);
  }, [templateCode]);

  return (
    <Modal
      centered={true}
      title="新建任务"
      width={650}
      className="modal-reset"
      styles={{ body: { maxHeight: 500, overflow: 'auto' } }}
      onCancel={onCancel}
      open={visible}
      footer={
        <div className="flex justify-end items-center h-15 ">
          <Button
            size="large"
            type="outline1"
            className="w-20 mr-4"
            onClick={onCancel}
          >
            取消
          </Button>
          <Button
            size="large"
            type="primary"
            onClick={handleSubmit}
            className="w-20"
            loading={btnDisabled}
          >
            确定
          </Button>
        </div>
      }
    >
      {selectVisible && (
        // 二级弹窗选择人员,直接添加到一级弹窗输入框中
        <MemberSelectModal
          userList={userList}
          departmentList={departmentList}
          visible={selectVisible}
          modalTitle="添加角色负责人"
          defaultCheckedList={defaultChecked}
          onDepartmentChange={handleDepartmentChange}
          onSearch={handleSearch}
          loading={loading}
          onOk={(val) => {
            getSecondSelectValue(val);
            setSelectVisible(false);
            handleSearch('');
          }}
          onClose={() => setSelectVisible(false)}
        />
      )}

      <Alert
        type="info"
        showIcon
        className="border-none"
        message="请选择流程节中,每个角色对应的负责人"
      />

      <div className="px-3 pt-5">
        <div className="flex items-center w-full h-[46px] bg-[#F9FAFD] text-secondary-2 font-medium shadow-[inset_0_-1px_0_0_#EEF2FB]">
          <p className="w-52 px-3">节点名称</p>
          <p className="w-40 px-3">角色</p>
          <p className="flex-1 px-3">负责人</p>
        </div>
        <Form
          form={form}
          className={styles['tm-form']}
          autoComplete="off"
          colon={false}
        >
          <Form.List name="users">
            {(fields) => {
              return (
                <>
                  {fields.map(({ key, ...restField }, index) => (
                    <div
                      key={key}
                      className="flex items-center h-auto min-h-[54px] shadow-[inset_0_-1px_0_0_#F1F4F8]"
                    >
                      <p className="w-52 px-3 flex-shrink-0">
                        {nodeDataList[index].name}
                      </p>
                      <p className="w-40  px-3 flex-shrink-0">
                        {nodeDataList[index].roles}
                      </p>
                      <div className="flex-1 px-3 py-2">
                        <Form.Item
                          {...restField}
                          rules={[{ required: true, message: '请选择负责人' }]}
                        >
                          <CustomSelect
                            options={nodeDataList[index].options}
                            showSelectModal={() => showSelect(index)}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  ))}
                </>
              );
            }}
          </Form.List>
        </Form>
        <div className="pb-6"></div>
      </div>
    </Modal>
  );
};
